<po-page-dynamic-table #dynamicTable p-title="Cadastro de Regras (Processamento de CT-e)"
  [p-breadcrumb]="breadcrumb" [p-concat-filters]="true" [p-infinite-scroll]="true"
  [p-service-api]="serviceApi" [p-actions]="actions" [p-fields]="fields" [p-hide-columns-manager]="true"
  [p-spacing]="poTableColumnSpacing" [p-page-custom-actions]="pageCustomActions"
  [p-actions-right]="false">

</po-page-dynamic-table>
